import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';

import toastr from 'helpers/toastr';
import cm from 'helpers/commons';
import CommonModal from './Modal/CommonModal';

const propTypes = {};

const defaultProps = {};

class BottomBtnArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      employeeAuth: cm.authGroupSet('employee'),
      mealcGorupAuth: cm.authGroupSet('meal-group')
    };
  }

  componentWillMount() {
    const { employeeAuth } = this.state;
  }

  ShowModalMod = (dimmer, header, size) => {
    const { data } = this.props;
    const { staffCheckedData } = data;
    if (header !== '직위 관리' && header !== '정보 변경내역' && staffCheckedData.length === 0) {
      toastr('top-right', 'warning', '사용자을 선택하세요.');
      return;
    }
    if (header !== '직위 관리' && header !== '정보 변경내역' && header === '계정 일시정지') {
      const inActiveUsers = [...staffCheckedData].filter((e) => e.status === 'INACTIVE');
      if (inActiveUsers.length > 0) {
        toastr('top-right', 'error', '일시정지된 사용자 입니다.');
        return;
      }
    }
    if (header !== '직위 관리' && header !== '정보 변경내역' && header === '일시정지 변경') {
      const notInActiveUsers = [...staffCheckedData].filter((e) => e.status !== 'INACTIVE');
      if (notInActiveUsers.length > 0) {
        toastr('top-right', 'error', '일시정지된 사용자가 아닙니다.');
        return;
      }
    }

    this.setState({
      dimmer,
      data,
      size: size || 'small',
      open: true,
      header
    });
  };

  closeModal = () => {
    this.setState({
      open: false,
      dimmer: false
    });
  };

  changeInfoModal = () => {
    const { fn } = this.props;
    const params = {
      page: 1,
      pageRow: 10,
      type: 'ALL'
    };
    try {
      fn.changeInfoSel(params);
    } catch (error) {
      console.log('##### error: ', error);
    }

    this.ShowModalMod(true, '정보 변경내역', 'large');
  };

  render() {
    const { data, fn, type } = this.props;
    const { open, dimmer, size, header, employeeAuth, create, update, mealcGorupAuth } = this.state;
    const modal = {
      open,
      size,
      dimmer,
      header,
      close: this.closeModal
    };

    const { staffCheckedData } = data;

    return (
      <div>
        {(employeeAuth.all || employeeAuth.create) && type !== 'dormant' ? (
          <div className="btn-group-one">
            <Button className="staff-management-btn" color="black" onClick={(e) => this.changeInfoModal()} inverted>
              정보 변경내역
            </Button>
          </div>
        ) : null}
        <div className="btn-group-two">
          {type !== 'dormant' ? (
            <Button
              className="position-btn"
              color="black"
              inverted
              onClick={(e) => this.ShowModalMod(true, '직위 관리')}
            >
              직위 관리
            </Button>
          ) : null}
          {(employeeAuth.all || employeeAuth.update) && type !== 'dormant' ? (
            <Button
              className="division-move-btn"
              color="black"
              inverted
              onClick={(e) => this.ShowModalMod(true, '부서 이동')}
            >
              부서 이동
            </Button>
          ) : null}
          {(mealcGorupAuth.all || mealcGorupAuth.assign) && type !== 'dormant' ? (
            <Button
              className="sikdaeGroup-btn"
              color="black"
              inverted
              onClick={(e) => this.ShowModalMod(true, '식대그룹 변경')}
            >
              식대그룹 변경
            </Button>
          ) : null}
          {employeeAuth.all || employeeAuth.update ? (
            <Button
              className="staffPause-btn"
              color="black"
              inverted
              onClick={(e) => this.ShowModalMod(true, '일시정지 변경')}
            >
              일시정지 변경
            </Button>
          ) : null}
          {employeeAuth.all || employeeAuth.update ? (
            <Button
              className="staffPause-btn"
              color="red"
              inverted
              onClick={(e) => this.ShowModalMod(true, '계정 일시정지')}
            >
              계정 일시정지
            </Button>
          ) : null}

          {employeeAuth.all || employeeAuth.delete ? (
            <Button className="resign-btn" color="red" inverted onClick={(e) => this.ShowModalMod(true, '계정 탈퇴')}>
              계정 탈퇴
            </Button>
          ) : null}
        </div>
        <CommonModal data={data} fn={fn} modal={modal} status={staffCheckedData} />
      </div>
    );
  }
}

BottomBtnArea.propTypes = propTypes;
BottomBtnArea.defaultProps = defaultProps;

BottomBtnArea.contextTypes = {
  router: PropTypes.object.isRequired
};

export default BottomBtnArea;
